export interface CampaignState {
  prepareModal: boolean;
  openConfirmationModal: boolean;
}

export const CampaignInitialState: CampaignState = {
  openConfirmationModal: false,
  prepareModal: false,
};
